"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const set_1 = require("./set");
/* DESTRUCTURING */
const { apply } = Reflect;
/* APPLICATORS */
const set = (method, thisArg, thisArgTarget, args) => {
    const [key, value] = args, prev = thisArgTarget.get(key);
    if (prev === value && (prev !== undefined || thisArgTarget.has(key)))
        return [thisArg, false];
    const result = apply(method, thisArg, args);
    return [result, true];
};
const del = set_1.default.delete;
const clear = set_1.default.clear;
/* MAP */
const Map = { set, delete: del, clear };
/* EXPORT */
exports.default = Map;
